/**
 * Block / unblock an account.
 *
 * The Admin API has no status-only endpoint — status changes go through the
 * same full-update pipeline the edit wizard uses: fetch the detail, map it
 * to form values, flip `accountStatus`, rebuild the PUT payload (with the
 * notify/templatify application lookups so app mappings survive) and update.
 */

import { getAccountById, updateAccount } from './accountService';
import { accountDetailToFormValues } from '../transforms/accountDetailToFormValues';
import { buildAccountPayload } from '../transforms/buildAccountPayload';
import { getAccountLookup } from '../hooks/useAccountLookup';
import type { AccountStatus } from '../types/account';

export const setAccountStatus = async (
  id: string,
  status: AccountStatus,
): Promise<void> => {
  const detail = await getAccountById(id);
  const values = accountDetailToFormValues(detail);
  values.accountStatus = status;
  const [notifyApps, templatifyApps] = await Promise.all([
    getAccountLookup('notifyApps'),
    getAccountLookup('templatifyApps'),
  ]);
  const body = buildAccountPayload(values, { notifyApps, templatifyApps });
  await updateAccount(detail.accountResponse.id, body);
};
